module.exports = __webpack_public_path__ + "img/recent-work-06.38ec89c3.jpg";